import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const MapComponent = ({ origin, destination, onRouteData }) => {
  const mapRef = useRef(null);

  useEffect(() => {
    if (!origin || !destination) return;

    const apiKey = "8c106eebc13c45c7a5de210023569379";

    // Initialize map
    const map = L.map(mapRef.current, {
      zoomControl: true,
      attributionControl: false,
    }).setView([22.585, 88.3426], 10);

    // Add a cleaner Google-like basemap
    L.tileLayer(
      `https://maps.geoapify.com/v1/tile/positron/{z}/{x}/{y}.png?apiKey=${apiKey}`,
      {
        maxZoom: 20,
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
      }
    ).addTo(map);

    // Custom Google-style markers
    const startIcon = L.icon({
      iconUrl: "https://maps.google.com/mapfiles/ms/icons/green-dot.png",
      iconSize: [40, 40],
      iconAnchor: [20, 40],
      popupAnchor: [0, -35],
    });

    const endIcon = L.icon({
      iconUrl: "https://maps.google.com/mapfiles/ms/icons/red-dot.png",
      iconSize: [40, 40],
      iconAnchor: [20, 40],
      popupAnchor: [0, -35],
    });

    const getCoordinates = async (place) => {
      const url = `https://api.geoapify.com/v1/geocode/search?text=${encodeURIComponent(
        place
      )}&apiKey=${apiKey}`;
      const res = await fetch(url);
      const data = await res.json();
      if (data.features?.length > 0) {
        const { lat, lon } = data.features[0].properties;
        return [lat, lon];
      } else throw new Error(`Could not find location: ${place}`);
    };

    const drawRoute = async () => {
      try {
        const location1 = await getCoordinates(origin);
        const location2 = await getCoordinates(destination);

        const startMarker = L.marker(location1, { icon: startIcon })
          .addTo(map)
          .bindPopup(`<b>Start:</b> ${origin}`);
        const endMarker = L.marker(location2, { icon: endIcon })
          .addTo(map)
          .bindPopup(`<b>End:</b> ${destination}`);

        const url = `https://api.geoapify.com/v1/routing?waypoints=${location1[0]},${location1[1]}|${location2[0]},${location2[1]}&mode=drive&apiKey=${apiKey}`;
        const response = await fetch(url);
        const data = await response.json();

        const routeLine = L.geoJSON(data, {
          style: {
            color: "#4285F4", // Google blue
            weight: 6,
            opacity: 0.9,
          },
        }).addTo(map);

        // Add glow effect (optional)
        const routeGlow = L.geoJSON(data, {
          style: {
            color: "#AECBFA",
            weight: 10,
            opacity: 0.4,
          },
        }).addTo(map);

        map.fitBounds(routeLine.getBounds(), { padding: [50, 50] });

        const routeProps = data.features[0].properties;
        const distanceKm = (routeProps.distance / 1000).toFixed(2);
        //const durationMin = (routeProps.time / 60).toFixed(1);
        //const durationMin = (routeProps.time / 3600).toFixed(1);
        const totalSeconds = routeProps.time;
        const hours = Math.floor(totalSeconds / 3600); // Get the whole hours
        const minutes = Math.floor((totalSeconds % 3600) / 60); // Get the remaining minutes

        const durationFormatted = `${hours}h ${minutes}m`;


        // Add popup on route
        // routeLine.bindPopup(
        //   `<b>Distance:</b> ${distanceKm} km<br/><b>Duration:</b> ${durationMin} min`
        // );

        if (onRouteData) {
          onRouteData({
            distanceKm: Number(distanceKm),
            // durationMin: Number(durationMin),
            durationMin: durationFormatted
          });
        }
      } catch (error) {
        console.error("Error fetching route:", error);
        if (onRouteData) onRouteData(null);
      }
    };

    drawRoute();

    return () => {
      map.remove();
    };
  }, [origin, destination]);

  return (
    <div style={{ width: "100%", height: "500px" }}>
      <div
        ref={mapRef}
        style={{
          width: "100%",
          height: "100%",
          borderRadius: "8px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
        }}
      ></div>
    </div>
  );
};

export default MapComponent;
